import { IApplicationState } from '../../types/redux';

export function selectNavbarDefaultRubrics(state: IApplicationState) {
  return state.navbarDefaultRubrics;
}
